class InspirationGallery {
	constructor(el) {
		// store references to our dom elements
		this.dom = {
			el,
			items: el.querySelectorAll(".inspiration-gallery__element"),
			modal: el.querySelector(".inspiration-gallery__modal"),
			modalImage: el.querySelector(".inspiration-gallery__modal-image"),
			modalContent: el.querySelector(".inspiration-gallery__modal-content"),
			modalControls: el.querySelector(".inspiration-gallery__modal-controls"),
		};

		this.currentItem = 0;

		// console.log("InspirationGallery", this.dom);

		if (!this.dom.el || !this.dom.items) return;

		const foundModal = this.dom.modalImage && this.dom.modalContent && this.dom.modalControls;

		let enlarge, share, prev, next;

		[...this.dom.items].forEach((item, idx) => {
			enlarge = item.querySelector(".inspiration-gallery__enlarge");
			if (foundModal && enlarge) {
				enlarge.addEventListener("click", () => this.enlargeClick(idx));
			}

			share = item.querySelector(".global-share-button .icon--share");
			if (share) {
				if (navigator.share) {
					share.classList.remove("hidden");
					share.addEventListener("click", this.shareClick);
				}
			}
		});

		jQuery(document).keydown(function (e) {
			if (e.which == 37) {
				// console.log("prev arrow");
				prev = this.dom.modalControls.querySelector(".inspiration-gallery__modal-prev");
				prev.addEventListener("click", () => this.prevClick());
			} else if (e.which == 39) {
				// console.log("next arrow");
				next = this.dom.modalControls.querySelector(".inspiration-gallery__modal-next");
				next.addEventListener("click", () => this.nextClick());
			}
		});

		prev = this.dom.modalControls.querySelector(".inspiration-gallery__modal-prev");
		if (prev) {
			// console.log("prev");
			prev.addEventListener("click", () => this.prevClick());
		}
		next = this.dom.modalControls.querySelector(".inspiration-gallery__modal-next");
		if (next) {
			next.addEventListener("click", () => this.nextClick());
		}

		jQuery(".inspiration-gallery__content-inner > p").each(function () {
			jQuery(this).html(
				jQuery(this)
					.html()
					.replace(/&nbsp;/gi, ""),
			);
		});
	}

	/**
	 * open gallery item in modal
	 */
	enlargeClick(idx) {
		// console.log(idx + " enlarge click");

		const item = this.dom.items.item(idx);
		const bg = item.querySelector(".inspiration-gallery__background");
		const content = item.querySelector(".inspiration-gallery__content");
		const bgSrc = bg.dataset.enlarged;

		// create new img tag to add to modal
		const img = document.createElement("img");

		img.src = bgSrc;

		// add it to the modal
		this.currentItem = idx;
		this.dom.modalImage.innerHTML = "";
		this.dom.modalImage.appendChild(img);

		// add item's content to the modal
		this.dom.modalContent.innerHTML = content.innerHTML;

		// show modal
		this.dom.modal.classList.add("is-visible");
		document.body.setAttribute("style", "overflow:hidden;");
		document.getElementById("global-header").setAttribute("style", "display:none;");
		document.getElementById("top-bar").setAttribute("style", "display:none;");
		document.getElementsByTagName("main")[0].setAttribute("style", "z-index:9997;");
		// set focus on close button when
		this.dom.modal.getElementsByClassName("modal__close")[0].focus();
	}

	/**
	 * activate share icons (by adding class to element)
	 */
	shareClick(event) {
		const share_title = event.currentTarget.dataset.title;
		const share_url = event.currentTarget.dataset.url;
		const share = {
			title: share_title,
			url: share_url,
		};
		navigator
			.share(share)
			.then(function () {})
			.catch();
	}

	openAnchor(anchor) {
		this.dom.items.forEach((item, idx) => {
			if (anchor == item.id) {
				// console.log("Inspiration Anchor Found", anchor);
				this.enlargeClick(idx);
				return true;
			}
		});
		return false;
	}

	prevClick() {
		let prevIDX = this.currentItem - 1;

		if (prevIDX < 0) {
			prevIDX = this.dom.items.length - 1;
		}
		// console.log("Previous Modal", prevIDX);
		this.enlargeClick(prevIDX);
	}

	nextClick() {
		let nextIDX = this.currentItem + 1;

		if (nextIDX > this.dom.items.length - 1) {
			nextIDX = 0;
		}
		// console.log("Next Modal", nextIDX);
		this.enlargeClick(nextIDX);
	}
}
function getAnchor() {
	return document.URL.split("#").length > 1 ? document.URL.split("#")[1] : null;
}
jQuery(document).ready(function () {
	let i;

	let gallerySections = document.querySelectorAll(".inspiration-gallery-section");

	let galleries = [];

	let anchor = getAnchor();

	for (i = 0; i < gallerySections.length; i++) {
		galleries.push(new InspirationGallery(gallerySections[i]));
	}

	if (anchor !== null) {
		// console.log(anchor);
		for (i = 0; i < galleries.length; i++) {
			if (galleries[i].openAnchor(anchor)) {
				break;
			}
		}
	}
});
